import React, {useState, useContext, useEffect} from "react";
import { LoginPage } from "../loginpage/loginpage";
import { AccountContext } from "./Account";
import { useNavigate, Navigate} from 'react-router-dom';
import Pool from "../UserPool";
const Status = () => {
    const [status, setStatus] = useState(false);
    const { getSession, logout } = useContext(AccountContext);
    let navigate = useNavigate();
    
    useEffect(() => {
            getSession().then(session => {
                console.log("Session",session)
                setStatus(true);
                sessionStorage.setItem("isAuth", true)
            });
           
            if(!status)
            {
                redirectToLogin();
            }
    }, []);
    const redirectToLogin = () => {
        const user = Pool.getCurrentUser();
        if(!user) {
            navigate("/login");

        }
    };
    
    // return <div> {status ? <button onClick={logout}>Logout</button> : 
    // ""}</div>
}

export default Status;